import { z } from "zod";
const copilotProposalIdSchema = z.uuid().brand();
function asCopilotProposalId(id) {
  return copilotProposalIdSchema.parse(id);
}
const allCopilotProposalStatuses = [
  "pending",
  "applied",
  "discarded",
  "stale"
];
const copilotProposalStatusSchema = z.enum(allCopilotProposalStatuses);
const copilotProposalResourceTypes = [
  "playbook",
  "signal",
  "automation",
  "teammateAgent",
  "knowledgeBaseAttachment",
  "training"
];
const copilotProposalResourceTypeSchema = z.enum(
  copilotProposalResourceTypes
);
function buildPlaybookProposalResourceKey(playbookId, playbookNodeId) {
  return `${playbookId}:${playbookNodeId}`;
}
const signalProposalKindSchema = z.enum([
  "create_signal",
  "update_signal"
]);
function buildSignalProposalResourceKey(signalId, kind) {
  return `${signalId}:${kind}`;
}
const automationProposalKindSchema = z.enum([
  "create_automation",
  "update_automation"
]);
function buildAutomationProposalResourceKey(automationId, kind) {
  return `${automationId}:${kind}`;
}
const copilotProposalSummarySchema = z.string().min(1).max(150);
const teammateAgentProposalKindSchema = z.enum([
  "update_instruction_section",
  "create_test_case",
  "update_test_case",
  "delete_test_case"
]);
function buildTeammateAgentTileProposalResourceKey(teammateAgentId, tile) {
  return `${teammateAgentId}:${tile}`;
}
function buildTeammateAgentTestCaseProposalResourceKey(teammateAgentId, testSpecId) {
  return `${teammateAgentId}:test-case:${testSpecId}`;
}
const trainingProposalKindSchema = z.enum([
  "create_training",
  "update_training"
]);
const playbookProposalKindSchema = z.enum([
  "create_criterion",
  "update_criterion",
  "delete_criterion",
  "create_section",
  "update_section",
  "delete_section",
  "update_outcome"
]);
const playbookProposalNodeTypeSchema = z.enum([
  "criteria",
  "section",
  "outcome"
]);
const playbookProposalActionSchema = z.enum([
  "create",
  "update",
  "delete"
]);
const PROPOSAL_TARGETS_BY_KIND = {
  create_criterion: { node_type: "criteria", action: "create" },
  update_criterion: { node_type: "criteria", action: "update" },
  delete_criterion: { node_type: "criteria", action: "delete" },
  create_section: { node_type: "section", action: "create" },
  update_section: { node_type: "section", action: "update" },
  delete_section: { node_type: "section", action: "delete" },
  // An outcome is a playbook-level rubric, so it is only ever rewritten.
  update_outcome: { node_type: "outcome", action: "update" }
};
function readPlaybookProposalTarget(kind) {
  return PROPOSAL_TARGETS_BY_KIND[kind];
}
function buildPlaybookProposalKind(target) {
  const kind = Object.entries(PROPOSAL_TARGETS_BY_KIND).find(
    ([, candidate]) => candidate.node_type === target.node_type && candidate.action === target.action
  )?.[0];
  if (!kind) {
    throw new Error(
      `No proposal kind stores a ${target.action} of a ${target.node_type}`
    );
  }
  return kind;
}
function checkCopilotProposalResourceType(proposal, resourceType) {
  return proposal.resource_type === resourceType;
}
export {
  allCopilotProposalStatuses,
  asCopilotProposalId,
  automationProposalKindSchema,
  buildAutomationProposalResourceKey,
  buildPlaybookProposalKind,
  buildPlaybookProposalResourceKey,
  buildSignalProposalResourceKey,
  buildTeammateAgentTestCaseProposalResourceKey,
  buildTeammateAgentTileProposalResourceKey,
  checkCopilotProposalResourceType,
  copilotProposalIdSchema,
  copilotProposalResourceTypeSchema,
  copilotProposalResourceTypes,
  copilotProposalStatusSchema,
  copilotProposalSummarySchema,
  playbookProposalActionSchema,
  playbookProposalKindSchema,
  playbookProposalNodeTypeSchema,
  readPlaybookProposalTarget,
  signalProposalKindSchema,
  teammateAgentProposalKindSchema,
  trainingProposalKindSchema
};
//# sourceMappingURL=copilotProposal.js.map
